import { Component, Input } from '@angular/core';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateCourseComponent } from "./create-course/create-course.component";

@Component({
  selector: 'app-courses',
  imports: [SharedModule, CreateCourseComponent],
  templateUrl: './courses.component.html',
  styleUrl: './courses.component.scss'
})
export class CoursesComponent {
  @Input() orgId!: string;
  totalRecords: number = 0;
  rows = 10;
  loading: boolean = true;
  displayAddModal = false;

  userLoading: boolean = false;
  courses: any[] = [];
  editCourseData: any = null;
  deleteCourse : boolean = false;

  campuses: any[] = [];
  departments: any[] = [];


  constructor(
    private orgService: OrganizationService,
  ) {

  }

  ngOnInit(): void {
    this.getAllDepartments();
    this.getAllCampus();
  }

  getAllDepartments() {
    const payload = {
      organization_id: this.orgId
    };
    this.orgService.getAllDepartment(payload).subscribe({
      next: (data) => {
        this.departments = data || [];
      },
      error: (err) => {
        console.error('❌ API Error:', err);
      }
    });
  }

  getAllCampus() {
    const payload = {
      organization_id: this.orgId
    };
    this.orgService.getAllCampus(payload).subscribe({
      next: (data) => {
        this.campuses = data || [];
      },
      error: (err) => {
        console.error('❌ API Error:', err);
      }
    });
  }




  openAddModal() {

    this.displayAddModal = true;
  }


  loadCourses(event: any, searchValue?: string, searchAttribute?: string): void {
    this.loading = true;
    const payload = {
      organization_id: this.orgId
    };

    this.orgService.getAllCourses(payload).subscribe({
      next: (data) => {
        this.courses = data || [];
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err);
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadCourses({ first: 0, rows: this.rows });
  }

  openDeleteCourse(data: any) {
    this.deleteCourse = true;
    this.editCourseData = data;
  }

}
